import { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, Button, Stack } from "@mui/material";
import { addDays, subDays } from "date-fns";
import { useSnackbar } from "notistack";
import ExportButton from "../exportButton";


function getUnixTimeStamp(date) {
    return Math.floor(date.getTime() / 1000);
}

function SearchFormCDR({ submitCallback, exportCallback }) {


    const [startDate, setStartDate] = useState(subDays(new Date(), 1));
    const [endDate, setEndDate] = useState(subDays(new Date(), 1));
    // const [type, setType] = useState('cumulative');
    const [maxEndDate, setMaxEndDate] = useState(new Date());

    const [maxStartDate, setMaxStartDate] = useState(subDays(new Date(), 1));

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        let newdate = addDays(startDate, 6);
        setMaxEndDate(newdate);
        if (endDate && ((startDate && (endDate.getTime() < startDate.getTime())) || endDate.getTime() > newdate.getTime())) {
            setEndDate(null);
        }
    }, [startDate]);

    function clickedCallback() {
        if (startDate === null || endDate === null) {
            return;
        }

        if (startDate.getTime() > endDate.getTime()) {
            enqueueSnackbar("Start date should be before End date", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }
            })
            return;
        }

        // let s = { startDate: getUnixTimeStamp(startDate), endDate: getUnixTimeStamp(endDate) };
        let s = { startDate: (startDate), endDate: (endDate) };
        // console.log(s);
        submitCallback(s);
    }
    function clickedCallbackCC() {
        if (startDate === null || endDate === null) {
            return;
        }

        if (startDate.getTime() > endDate.getTime()) {
            enqueueSnackbar("Start date should be before End date", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }
            })
            return;
        }

        // let s = { startDate: getUnixTimeStamp(startDate), endDate: getUnixTimeStamp(endDate) };
        let s = { startDate: (startDate), endDate: (endDate) };
        // console.log(s);
        exportCallback(s);
    }

    function clicked2Callback() {

        if (startDate === null || endDate === null) {
            return;
        }

        if (startDate.getDate() === endDate.getDate()) {
            //check yesterday now
            let y = subDays(new Date(), 1);
            if (startDate.getDate() === y.getDate()) {
                //so requesting for yesterday
                let now = new Date();

                if (now.getHours() < 1 && now.getMinutes() < 30) {
                    enqueueSnackbar("For requesting yesterdays data Please try after 12:30 AM ", {
                        variant: 'error',
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        }
                    });
                    return;
                }
            }
        }

        if (startDate.getTime() > endDate.getTime()) {
            enqueueSnackbar("Start date should be before End date", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }
            })
            return;
        }

        let s = { startDate: (startDate), endDate: (endDate) };
        // console.log(s);
        exportCallback(s);
    }


    function handleSetEndDate(date) {
        if (date) {
            date.setHours(23, 59, 59);
        }
        setEndDate(date)
    }

    return <>

        <Box sx={{ padding: '20px 60px', border: '1px solid #eee' }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 3, md: 6 }} justifyContent='center' alignItems='center'>
                <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={(newValue) => {
                        setStartDate(newValue);
                    }}
                    format="dd/MM/yyyy"
                    maxDate={maxStartDate}
                    renderInput={(params) => <TextField {...params} />} />

                <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={(newValue) => {
                        handleSetEndDate(newValue);
                    }}
                    format="dd/MM/yyyy"
                    minDate={startDate}
                    maxDate={maxEndDate}
                    renderInput={(params) => <TextField {...params} />} />

                {/*                <Select onChange={e => setType(e.target.value)}
                        value={type}>
                    <MenuItem value={'cumulative'}>Cumulative</MenuItem>
                    <MenuItem value={'datewise'}>DateWise</MenuItem>
                </Select>*/}

                <Button variant="outlined" onClick={clickedCallback}>Search</Button>
                
                {/* {((startDate != null && endDate != null && exportCallback) && <ExportButton variant="outlined" onClick={clickedCallbackCC}>Export</ExportButton>)} */}
            </Stack>

        </Box>

    </>
}

export default SearchFormCDR;
